import React from "react";
import { addHtmlElementClass, removeHtmlElement, removeHtmlElementClass } from "../../utils/utils";

const GlobalSearchIcon = ({ }) => {

  return (
    <img src="/images/search.svg" id="global_search_icon" className="ml-2 ml-xxl-4 cursor-pointer" alt="Search" height="27" width="27" onClick={() => {
      // removeHtmlElementClass(document, "global-search-bar-container", 'slide-up');
      removeHtmlElementClass(document, "navbar_menu", 'd-xl-flex');
      removeHtmlElementClass(document, "navbar-search", 'slide-up');
      addHtmlElementClass(document, "navbar-search", 'slide-down-searchbar');
      addHtmlElementClass(document, "global_search_bar", 'slide-down-searchbar-input');
      addHtmlElementClass(document, "global_search_button", 'slide-down-searchbar-button');
      addHtmlElementClass(document, "global_search_close", 'slide-down-searchbar-close');
      addHtmlElementClass(document, "global_search_bar_second_row", 'slide-down-searchbar-input');
      addHtmlElementClass(document, "global_search_button_second_row", 'slide-down-searchbar-button');
      addHtmlElementClass(document, "global_search_close_second_row", 'slide-down-searchbar-close');
      addHtmlElementClass(document, "navbar-second-line", "slide-down")
      // addHtmlElementClass(document, "global-search-bar-container", 'slide-down');
    }}
    />
  );
};

export default GlobalSearchIcon;
